// src/common/PhoneField.js
import { Box } from '@mui/system';
import { Button, IconButton, Popover, TextField } from '@mui/material';
import { styled  } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { AppStyle, AppWord } from '../value/AppConst';
import { useEffect, useRef, useState } from 'react';
import ValueMisc from '../value/ValueMisc';

const InputFieldContainer = styled(Box)({
    display: 'flex', alignItems: 'center',
});
const AreaCodeBox = styled(Box)({
    margin:5, border: AppStyle.BorderCCC, borderRadius: 3, display:'flex'
});
const AreaColumn = styled(Box)({
    display: 'flex', flexDirection: 'column', width: 120, margin:2,
});
const AreaUpper = styled(Box)({flexGrow:1});

/*
서울	인천	대전	부산	울산	대구	광주	제주
02	032	042	051	052	053	062	064
경기	강원	충남	충북	경북	경남	전남	전북
031	033	041	043	054	055	061	063
*/
const NoAreaCode = 'x';
const AreaCode = {
    mobile: [
        {label:'010', code:'010'},
        {label:'011', code:'011'},
        {label:'016', code:'016'},
        {label:'017', code:'017'},
        {label:'018', code:'018'},
        {label:'019', code:'019'},
    ],
    area1: [
        {label:'서울(02)', code:'02'},
        {label:'부산(051)', code:'051'},
        {label:'광주(062)', code:'062'},
        {label:'대전(042)', code:'042'},
        {label:'세종(044)', code: '044'},
        {label:'울산(052)', code:'052'},
        {label:'인천(032)', code:'032'},
    ],
    area2: [

        {label:'경기(031)', code:'031'},
        {label:'경남(055)', code:'055'},
        {label:'경북(054)', code:'054'},
        {label:'대구(053)', code:'053'},
        {label:'제주(064)', code:'064'},
        {label:'강원(033)', code:'033'},
        {label:'충남(041)', code:'041'},
        {label:'충북(043)', code:'043'},
        {label:'전남(061)', code:'061'},
        {label:'전북(063)', code:'063'},
    ],
    etc: [
    {label:'전국(070)', code: '070'},
    {label:'기타(080)', code: '080'},
    {label:'삭제', code: NoAreaCode},
    ],
};


export default function PhoneField({
    dict,
    value,
    onChange,
    size,
    isMobile, // true: mobile, false: any
}) {
    const [sect, setSect] = useState(['', '', '']);
    const [anchorEl, setAnchorEl] = useState(null);
    const [error, setError] = useState(false);
    const iconButtonRef = useRef(null);

    useEffect(()=>{
        setSect(ValueMisc.splitPhoneNumber(value));
    }, [value]);
    const fieldSize = size ? size : AppWord.SMALL;

    const onChangeAny = (sectsNew) => {
        const sects = sectsNew.map((item) => Boolean(item) ? item : '');
        let isError = false;
        let value = sects.join('-');
        if(
            sects[0].length>0 && sects[1].length>0 && sects[2].length>0
        ) {
            isError = false;
            // else onChange(dict.id, sects[1] + '-' + sects[2]);
        }
        else {
            if(value==='--') {
                isError = false;
                value = null;
            }
            else {
                isError = true;
            }
        }
        setError(isError);
        setSect(sects);
        onChange(dict.id, value, isError);
    }

    const onChangeGroupNumber = (e) => {
        const newSect = [...sect];
        newSect[0] = e.target.value;
        onChangeAny(newSect);
    };

    const onClickAreaButton = (code) => {
        setAnchorEl(null);
        if(code===NoAreaCode) {
            onChangeAny(['', '', '']);
        }
        else onChangeGroupNumber({target:{value:code}});
    };

    const onChangeMiddleNumber = (e) => {
        const newSect = [...sect];
        newSect[1] = e.target.value;
        onChangeAny(newSect);
    };

    const onChangeLastNumber = (e) => {
        const newSect = [...sect];
        newSect[2] = e.target.value;
        onChangeAny(newSect);
    };

    const InputID = dict.id + 'search-box-input';

    return(
        <InputFieldContainer>
            <TextField id={InputID} onChange={onChangeGroupNumber}
                value={sect[0]}
                size={fieldSize}
                label={dict.label}
                style={{width: 110}}
                error={error}
            />
            <IconButton
                ref={iconButtonRef}
                onClick={(e)=>{setAnchorEl(e.currentTarget)}}
                size={AppWord.SMALL}
                style={{marginLeft:-30}}
                color={AppStyle.mui.primary}
            >
                <ArrowDropDownIcon />
            </IconButton>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={()=>{setAnchorEl(null)}}
                anchorOrigin={{vertical:'top', horizontal:'left'}}
                transformOrigin={{vertical:'top', horizontal:'left'}}
            >
                {
                    isMobile ?
                    <AreaCodeBox>
                        <AreaColumn>
                            <AreaUpper>
                                {
                                    AreaCode.mobile.map((item, index)=>{
                                        return(
                                            <Box key={index}>
                                                <Button variant={AppStyle.mui.text}
                                                    onClick={()=>{onClickAreaButton(item.code)}}
                                                >{item.label}</Button>
                                            </Box>
                                        );
                                    })
                                }
                            </AreaUpper>
                            <Box>
                                {AreaCode.etc
                                    .filter((c)=>c.code===NoAreaCode)
                                    .map((item, index)=>{
                                    return(
                                        <Box key={index}>
                                            <Button variant={
                                                item.code===NoAreaCode ? AppStyle.mui.outlined :
                                                AppStyle.mui.text
                                                }
                                                onClick={()=>{onClickAreaButton(item.code)}}
                                            >{item.label}</Button>
                                        </Box>
                                    );
                                })}
                            </Box>
                        </AreaColumn>
                    </AreaCodeBox>
                    :
                    <AreaCodeBox>
                        <AreaColumn>
                            <AreaUpper>
                                {
                                    AreaCode.mobile.map((item, index)=>{
                                        return(
                                            <Box key={index}>
                                                <Button variant={AppStyle.mui.text}
                                                    onClick={()=>{onClickAreaButton(item.code)}}
                                                >{item.label}</Button>
                                            </Box>
                                        );
                                    })
                                }
                            </AreaUpper>
                            <Box>
                                {AreaCode.etc.map((item, index)=>{
                                    return(
                                        <Box key={index}>
                                            <Button variant={
                                                item.code===NoAreaCode ? AppStyle.mui.outlined :
                                                AppStyle.mui.text
                                                }
                                                onClick={()=>{onClickAreaButton(item.code)}}
                                            >{item.label}</Button>
                                        </Box>
                                    );
                                })}
                            </Box>
                        </AreaColumn>
                        <AreaColumn>
                            {
                                AreaCode.area1.map((item, index)=>{
                                    return(
                                        <Box key={index}>
                                            <Button variant={AppStyle.mui.text}
                                                onClick={()=>{onClickAreaButton(item.code)}}
                                            >{item.label}</Button>
                                        </Box>
                                    );
                                })
                            }
                        </AreaColumn>
                        <AreaColumn>
                            {
                                AreaCode.area2.map((item, index)=>{
                                    return(
                                        <Box key={index}>
                                            <Button variant={
                                                item.code===NoAreaCode ? AppStyle.mui.outlined :
                                                AppStyle.mui.text
                                            }
                                                onClick={()=>{onClickAreaButton(item.code)}}
                                            >{item.label}</Button>
                                        </Box>
                                    );
                                })
                            }
                        </AreaColumn>
                    </AreaCodeBox>}
            </Popover>
            <TextField
                size={fieldSize}
                label={null}
                value={sect[1]}
                error={error}
                onChange={onChangeMiddleNumber}
                style={{width: 90, marginLeft: 5}}
            />
            <TextField
                size={fieldSize}
                label={null}
                value={sect[2]}
                error={error}
                onChange={onChangeLastNumber}
                style={{width: 90, marginLeft: 5}}
            />
        </InputFieldContainer>
    );
}
